import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

import { discussionVoteRemove } from "~/store/graphql/mutations/discussionVoteRemove.graphql";

const createDiscussionVote = async function (
  { commit, state },
  { discussionReplyId, parentDiscussionReplyId }
) {
  commit("START_LOADING");

  await runGraphQLQuery(
    discussionVoteRemove,
    {
      entityId: discussionReplyId,
      entityType: "DISCUSSION_REPLY",
    },
    this.$axios
  );

  commit("REMOVE_DISCUSSION_REPLY_VOTE", {
    discussionReplyId,
    parentDiscussionReplyId,
  });

  commit("END_LOADING");

  return Promise.resolve();
};

export default createDiscussionVote;
